import Node from './shared/Node';

export default class EventHandler extends Node {
	name: string;
	value: Node[]
	expression: Node
}